
import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import { SubscriptionBanner } from './common/SubscriptionBanner';

interface AuthenticatedLayoutProps {
  children: React.ReactNode;
}

const AuthenticatedLayout: React.FC<AuthenticatedLayoutProps> = ({ children }) => {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const location = useLocation();

  // Determine active tab based on current route
  const getActiveTabFromRoute = () => {
    const path = location.pathname;
    if (path === '/') return 'dashboard';
    if (path.startsWith('/campaigns')) return 'campaigns';
    if (path.startsWith('/influencers')) return 'influencers';
    if (path.startsWith('/discovery')) return 'discovery';
    if (path.startsWith('/brands')) return 'brands';
    if (path.startsWith('/contacts')) return 'contacts';
    if (path.startsWith('/events')) return 'events';
    if (path.startsWith('/vendors')) return 'vendors';
    if (path.startsWith('/notifications')) return 'inbox';
    if (path.startsWith('/email-center')) return 'email-center';
    if (path.startsWith('/analytics')) return 'analytics';
    if (path.startsWith('/payments')) return 'payments';
    if (path.startsWith('/user-management')) return 'user-management';
    if (path.startsWith('/calendar')) return 'calendar';
    if (path.startsWith('/settings')) return 'settings';
    return 'dashboard';
  };

  const currentActiveTab = getActiveTabFromRoute();

  return (
    <div className="min-h-screen bg-gray-50 flex">
      <Sidebar
        activeTab={currentActiveTab}
        setActiveTab={setActiveTab}
        onCollapsedChange={setIsSidebarCollapsed}
      />
      <main
        className={`flex-1 overflow-auto transition-all duration-300 ease-in-out ${
          isSidebarCollapsed ? 'ml-[72px]' : 'ml-64'
        }`}
      >
        <SubscriptionBanner />
        {children}
      </main>
    </div>
  );
};

export default AuthenticatedLayout;
